'use strict';

/* eslint no-undef: "off" */
/**
 * XPark brand story
 */
define('xparkBrandStory',['swiper', 'xparkHomepageApi', 'appStorage'], function (Swiper, xparkHomepageApi, appStorage) {
  function clamp(value) {
    return Math.max(0, Math.min(1, value));
  }

  function getScrollContainer(root) {
    if (!root || !root.closest) {
      return window;
    }

    return root.closest('.in-slider-container.in-slider-header-container') || root.closest('.in-slider-container') || window;
  }

  function getScrollTop(container) {
    if (container === window) {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    return container.scrollTop || 0;
  }

  function getContainerHeight(container) {
    if (container === window) {
      return window.innerHeight || document.documentElement.clientHeight || 0;
    }

    return container.clientHeight || 0;
  }

  function getElementTopWithinContainer(element, container) {
    if (!element) {
      return 0;
    }

    if (container === window) {
      return element.getBoundingClientRect().top + getScrollTop(window);
    }

    var elementRect = element.getBoundingClientRect();
    var containerRect = container.getBoundingClientRect();

    return getScrollTop(container) + (elementRect.top - containerRect.top);
  }

  return {
    template: '\n      <section ref="brandStoryRoot" class="xp-brand-story" v-if="hasContent">\n        <div ref="stickyWrap" class="sticky-wrap">\n          <div ref="stickyAni" class="sticky-ani">\n            <div ref="stickyContent" class="sticky-content">\n              <h2>Brand Story</h2>\n              <div ref="bannerContent" class="xp-banner-content" v-if="banner.videoUrl || banner.floatImage">\n                <div ref="videoWrap" class="xp-banner-video-wrap">\n                  <video\n                    ref="bannerVideo"\n                    class="xp-banner-video"\n                    :src="banner.videoUrl"\n                    muted\n                    playsinline\n                    webkit-playsinline\n                    preload="metadata"\n                  ></video>\n                  <img\n                    class="xp-banner-phone-frame"\n                    :src="require.toUrl(\'images/phone_frame.png\')"\n                  />\n                  <img\n                    v-if="banner.floatImage"\n                    ref="floatImage"\n                    class="xp-banner-float-image"\n                    :src="banner.floatImage"\n                    alt=""\n                  />\n                </div>\n                <p v-text="banner.desc"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div ref="featureWrap" class="xp-feature-wrap" v-if="featureList.length">\n          <div v-if="loading" class="skeleton-loading"></div>\n          <div class="xp-feature-grid">\n            <a\n              v-for="item in featureList"\n              :key="item.title"\n              class="xp-feature-card"\n              :href="item.url"\n              :aria-label="item.title"\n            >\n              <img :src="item.image" :alt="item.title" />\n              <span class="xp-feature-title" v-text="item.title"></span>\n            </a>\n          </div>\n        </div>\n\n        <div class="xp-brand-news">\n          <div v-if="loading" class="skeleton-loading"></div>\n          <div class="xp-brand-news-track swiper-container" ref="newsSwiper">\n            <div class="swiper-wrapper">\n              <a\n                v-for="item in newsList"\n                :key="item.title + item.date"\n                class="xp-brand-news-card swiper-slide"\n                :href="item.url"\n                :aria-label="item.title"\n              >\n                <img :src="item.image" :alt="item.title" />\n                <h3 v-text="item.title"></h3>\n                <p v-text="item.desc"></p>\n                <time v-if="item.date" v-text="item.date"></time>\n              </a>\n            </div>\n          </div>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        banner: {
          videoUrl: '',
          floatImage: '',
          desc: ''
        },
        brandStoryScrollEls: null,
        brandStoryScrollRaf: null,
        brandStoryScrollHandler: null,
        brandStoryResizeHandler: null,
        brandStoryLayoutRaf: null,
        brandStoryScrollContainer: null,
        brandStoryScrollInitialized: false,
        brandStoryVideoInRange: false,
        newsSlider: null,
        newsSliderTimer: null,
        featureList: [],
        newsList: [],
        loading: false
      };
    },
    created: function created() {
      var data = appStorage.get("brandStory");
      if (data) {
        var json = JSON.parse(data);
        if (json && json.banner) this.banner = json.banner;
        if (json && json.featureList) this.featureList = json.featureList;
        if (json && json.newsList) this.newsList = json.newsList;
      }
    },

    computed: {
      hasContent: function hasContent() {
        return Boolean(this.banner.videoUrl || this.featureList.length || this.newsList.length);
      }
    },
    mounted: function mounted() {
      var _this = this;

      this.fetchBrandStory();
      this.$nextTick(function () {
        _this.initNewsSlider();
        _this.ensureBrandStoryScroll();
        _this.scheduleBrandStoryLayoutUpdate();
      });
    },
    updated: function updated() {
      this.ensureBrandStoryScroll();
      this.scheduleBrandStoryLayoutUpdate();
    },
    beforeDestroy: function beforeDestroy() {
      this.destroyBrandStoryScroll();

      if (this.newsSliderTimer) {
        window.clearTimeout(this.newsSliderTimer);
      }

      if (this.newsSlider && this.newsSlider.destroy) {
        this.newsSlider.destroy(true, true);
      }
    },

    methods: {
      fetchBrandStory: function fetchBrandStory() {
        var _this2 = this;

        this.loading = true;
        xparkHomepageApi.getBrandStory().then(function (data) {
          if (!data) {
            return;
          }

          if (data.video && (data.video.video_url || data.video.float_image)) {
            _this2.banner = {
              videoUrl: data.video.video_url || '',
              floatImage: data.video.float_image || '',
              desc: data.video.content || data.video.title || ''
            };
          }

          if (Array.isArray(data.image_tiles) && data.image_tiles.length) {
            _this2.featureList = data.image_tiles.map(function (item) {
              return {
                image: item.image_url || '',
                title: item.title || '',
                url: item.url || 'javascript:void(0);'
              };
            }).filter(function (item) {
              return item.image;
            });
          }

          if (Array.isArray(data.scroll_banners) && data.scroll_banners.length) {
            _this2.newsList = data.scroll_banners.map(function (item) {
              return {
                image: item.image_url || '',
                title: item.title || '',
                desc: item.content || '',
                date: item.date || '',
                url: item.url || 'javascript:void(0);'
              };
            }).filter(function (item) {
              return item.image;
            });

            _this2.$nextTick(function () {
              _this2.resetNewsSlider();
            });
          }

          _this2.$nextTick(function () {
            _this2.initBrandStoryScroll();
            var saveData = {
              banner: _this2.banner,
              featureList: _this2.featureList,
              newsList: _this2.newsList
            };
            appStorage.set('brandStory', JSON.stringify(saveData));
          });
        }).catch(function () {}).finally(function () {
          return _this2.loading = false;
        });
      },
      destroyBrandStoryScroll: function destroyBrandStoryScroll() {
        if (this.brandStoryScrollRaf) {
          window.cancelAnimationFrame(this.brandStoryScrollRaf);
          this.brandStoryScrollRaf = null;
        }

        if (this.brandStoryLayoutRaf) {
          window.cancelAnimationFrame(this.brandStoryLayoutRaf);
          this.brandStoryLayoutRaf = null;
        }

        if (this.brandStoryScrollHandler && this.brandStoryScrollContainer) {
          this.brandStoryScrollContainer.removeEventListener('scroll', this.brandStoryScrollHandler);
        }

        if (this.brandStoryResizeHandler) {
          window.removeEventListener('resize', this.brandStoryResizeHandler);
          this.brandStoryResizeHandler = null;
        }

        this.brandStoryScrollHandler = null;
        this.brandStoryScrollContainer = null;
        this.brandStoryScrollEls = null;
        this.brandStoryScrollInitialized = false;
        this.brandStoryVideoInRange = false;
      },
      syncBrandStoryVideo: function syncBrandStoryVideo(progress) {
        var _this3 = this;

        var video = this.$refs.bannerVideo;

        if (!video || !this.banner.videoUrl) {
          return;
        }

        var hasEnteredStory = progress > 0 && progress < 1;

        if (hasEnteredStory && !this.brandStoryVideoInRange) {
          this.brandStoryVideoInRange = true;
          var playPromise = video.play();

          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {
              _this3.brandStoryVideoInRange = false;
            });
          }
          return;
        }

        if (!hasEnteredStory) {
          this.brandStoryVideoInRange = false;
        }
      },
      scheduleBrandStoryLayoutUpdate: function scheduleBrandStoryLayoutUpdate() {
        var _this4 = this;

        if (this.brandStoryLayoutRaf) {
          return;
        }

        this.brandStoryLayoutRaf = window.requestAnimationFrame(function () {
          _this4.brandStoryLayoutRaf = null;
          _this4.updateBrandStoryLayout();
        });
      },
      updateBrandStoryLayout: function updateBrandStoryLayout() {
        var stickyContent = this.$refs.stickyContent;
        var featureWrap = this.$refs.featureWrap;

        if (!stickyContent || !featureWrap) {
          return;
        }

        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        var stickyContentHeight = stickyContent.getBoundingClientRect().height || stickyContent.scrollHeight || stickyContent.offsetHeight || viewportHeight;
        var extraSpacing = (stickyContentHeight - viewportHeight) / 2 + 24;

        featureWrap.style.marginTop = extraSpacing.toFixed(2) + 'px';
      },
      ensureBrandStoryScroll: function ensureBrandStoryScroll() {
        if (!this.hasContent) {
          this.destroyBrandStoryScroll();
          return;
        }

        if (this.brandStoryScrollInitialized) {
          return;
        }

        var root = this.$refs.brandStoryRoot;
        var stickyWrap = this.$refs.stickyWrap;
        var stickyContent = this.$refs.stickyContent;
        var bannerContent = this.$refs.bannerContent;
        var videoWrap = this.$refs.videoWrap;

        if (!root || !stickyWrap || !stickyContent || !bannerContent || !videoWrap) {
          return;
        }

        this.initBrandStoryScroll();
        this.scheduleBrandStoryLayoutUpdate();
      },
      initBrandStoryScroll: function initBrandStoryScroll() {
        var root = this.$refs.brandStoryRoot;

        if (!root) {
          return;
        }

        var stickyWrap = this.$refs.stickyWrap;
        var bannerContent = this.$refs.bannerContent;
        var videoWrap = this.$refs.videoWrap;
        var title = root.querySelector('h2');
        var desc = bannerContent.querySelector('p');
        var floatImage = this.$refs.floatImage || root.querySelector('.xp-banner-float-image');

        if (!stickyWrap || !bannerContent || !videoWrap || !title || !desc) {
          return;
        }

        this.destroyBrandStoryScroll();

        this.brandStoryScrollContainer = getScrollContainer(root);
        this.brandStoryScrollEls = {
          stickyWrap: stickyWrap,
          videoWrap: videoWrap,
          title: title,
          desc: desc,
          floatImage: floatImage
        };
        this.brandStoryScrollInitialized = true;
        this.brandStoryScrollHandler = this.scheduleBrandStoryScrollUpdate.bind(this);
        this.brandStoryResizeHandler = this.scheduleBrandStoryScrollUpdate.bind(this);

        this.brandStoryScrollContainer.addEventListener('scroll', this.brandStoryScrollHandler, { passive: true });
        window.addEventListener('resize', this.brandStoryResizeHandler);
        this.scheduleBrandStoryScrollUpdate();
        this.scheduleBrandStoryLayoutUpdate();
      },
      scheduleBrandStoryScrollUpdate: function scheduleBrandStoryScrollUpdate() {
        var _this5 = this;

        if (this.brandStoryScrollRaf) {
          return;
        }

        this.brandStoryScrollRaf = window.requestAnimationFrame(function () {
          _this5.brandStoryScrollRaf = null;
          _this5.updateBrandStoryScroll();
        });
      },
      updateBrandStoryScroll: function updateBrandStoryScroll() {
        var state = this.brandStoryScrollEls;

        if (!state) {
          return;
        }

        var container = this.brandStoryScrollContainer || window;
        var scrollTop = getScrollTop(container);
        var containerHeight = getContainerHeight(container);
        var stickyTop = getElementTopWithinContainer(state.stickyWrap, container);
        var scrollRange = state.stickyWrap.offsetHeight - containerHeight;
        var progress = scrollRange > 0 ? clamp((scrollTop - stickyTop) / scrollRange) : 1;
        var titleProgress = clamp((progress - 0.78) / 0.22);
        var descProgress = clamp((progress - 0.84) / 0.16);
        var floatProgress = clamp((progress - 0.9) / 0.1);
        var videoScale = 5.2 - 4.2 * progress;

        this.syncBrandStoryVideo(progress);
        state.videoWrap.style.transformOrigin = '50% 50%';
        state.videoWrap.style.transform = 'scale(' + videoScale.toFixed(4) + ')';
        state.title.style.opacity = String(titleProgress);
        state.title.style.transform = 'translateY(' + ((1 - titleProgress) * 24).toFixed(2) + 'px)';
        state.desc.style.opacity = String(descProgress);
        state.desc.style.transform = 'translateY(' + ((1 - descProgress) * 20).toFixed(2) + 'px)';

        if (state.floatImage) {
          state.floatImage.style.opacity = String(floatProgress);
          state.floatImage.style.transform = 'translate(-50%, -50%) translateY(' + ((1 - floatProgress) * 16).toFixed(2) + 'px)';
        }
      },
      resetNewsSlider: function resetNewsSlider() {
        if (this.newsSliderTimer) {
          window.clearTimeout(this.newsSliderTimer);
          this.newsSliderTimer = null;
        }

        if (this.newsSlider && this.newsSlider.destroy) {
          this.newsSlider.destroy(true, true);
          this.newsSlider = null;
        }

        this.initNewsSlider();
      },
      initNewsSlider: function initNewsSlider() {
        var _this6 = this;

        var container = this.$refs.newsSwiper;

        if (!container || this.newsList.length < 2) {
          return;
        }

        this.newsSliderTimer = window.setTimeout(function () {
          _this6.newsSlider = new Swiper(container, {
            centeredSlides: true,
            loop: true,
            loopAdditionalSlides: _this6.newsList.length,
            loopedSlides: _this6.newsList.length,
            observer: true,
            observeParents: true,
            slidesPerView: 'auto',
            spaceBetween: 12,
            speed: 350
          });
        }, 20);
      }
    }
  };
});
